export const en = {
  system_name: 'CDN User Diagnostic System',
  system_check_button: 'Check',
  ip_info: 'IP Info',
  local_ip: 'Local IP:',
  local_dns: 'Local DNS:',
  probe_sever_info: 'Probe Sever Info',
  domain_name: 'Domain:',
  recommend_resolution_ip: 'Recommend Resolution IP:',
  status_code: 'Status Code:',
  network_delay: 'Network Delay:',
  download_speed: 'Download Speed:',
  system_environment_information: 'System Info',
  time: 'Time:',
  user_agent: 'User Agent:',
  footer_copyright: 'Copyright © Huawei Technologies Co., Ltd.  2022.  All rights reserved.'

}



//////////////////
// WEBPACK FOOTER
// ./static/en.js
// module id = null
// module chunks = 